module.exports = __webpack_public_path__ + "img/scrmT5.255db5a3.png";